import React from 'react';
import { Box, Typography } from '@mui/material';
import { errorBoxStyles, errorMessageStyles, errorHelperTextStyles } from '../../../constants/escalateQueryDialog';

/**
 * ErrorDisplay Component
 * Shows error message when escalation options fail to load
 */
const ErrorDisplay = ({ loadError }) => {
  if (!loadError) return null;

  return (
    <Box sx={errorBoxStyles}>
      <Typography variant="body1" sx={errorMessageStyles}>
        {loadError}
      </Typography>
      <Typography variant="body2" sx={errorHelperTextStyles}>
        Please verify the query still exists and that you have permission to escalate it.
      </Typography>
    </Box>
  );
};

export default ErrorDisplay;
